import { IconSVGProps } from "./types";

const notificationDotIcon = ({ widths = 20, height = 20 }: IconSVGProps) => (
    <svg width={widths} height={height} viewBox="0 0 10 10" style={{ opacity: 1 }} className="bi bi-dot" fill="orange" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
    </svg>
);

export default notificationDotIcon;
